import { MemberStatusEnum } from '@/api/enum/common.enum';

const ADMITTED_STATUSES: number[] = [
	MemberStatusEnum.InProgressAdmitted,
	MemberStatusEnum.AwaitingAssignmentAdmitted,
	MemberStatusEnum.PendingIntakeAdmitted,
	MemberStatusEnum.IntakeCompletedAdmitted,
	MemberStatusEnum.All,
];

/**
 * Detail page of a record returned by the duplication checks:
 * Pre-admission while `status` is null, Member once admitted (or closed),
 * otherwise Admission Request.
 */
export const getMemberRecordLink = (id: string, status?: number | null) => {
	if (status === null || status === undefined) {
		return `/pre-admission/pre-admission-list/detail/${id}`;
	}
	if (ADMITTED_STATUSES.includes(status)) {
		return `/member-management/member-list/detail/${id}`;
	}
	return `/member-management/admission-request-list/detail/${id}`;
};
